import startCase from 'lodash/startCase';
import kebabCase from 'lodash/kebabCase';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import useSWR from 'swr';

import { SearchTitle, SearchBoxButton } from 'search/styles/SearchStyles';
import { RecentSearchesCache } from 'search/utils/RecentSearchesCache';
import { Loader } from 'shared/components/Loader';
import { requestService } from 'shared/utils/services/requestService';
import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';

const fetchLatestSearches = async () => {
  return requestService({
    url: '/web-api/v1/search-metadata/latest-searches',
    method: 'GET',
  });
};

export const LatestSearches = () => {
  const router = useRouter();
  const { data, error } = useSWR('latest-searches', fetchLatestSearches);
  const latestSearches = data?.searches?.slice(0, 10) || [];

  const handleClick = (latestSearch: string) => {
    RecentSearchesCache.add(latestSearch);
    void router.push(`/search?query=${latestSearch}`);

    sendTrackingEvent('SEARCH_LATEST_TAP', {
      search_string: latestSearch,
    });
  };

  if (error || latestSearches.length === 0) {
    return null;
  }

  if (!latestSearches) {
    return <Loader style={{ margin: '30px 0' }} />;
  }

  return (
    <LatestSearches.Wrapper>
      <LatestSearches.Title>Latest searches</LatestSearches.Title>
      {latestSearches.map((value) => (
        <SearchBoxButton key={kebabCase(value)} onClick={() => handleClick(startCase(value))}>
          {startCase(value)}
        </SearchBoxButton>
      ))}
    </LatestSearches.Wrapper>
  );
};

LatestSearches.Wrapper = styled.div`
  margin-bottom: 24px;
`;

LatestSearches.Title = styled(SearchTitle)`
  ${SearchTitle};
  margin-bottom: 16px;
`;
